import React from "react";
import PropTypes from "prop-types";
import { TailSpin } from "react-loader-spinner";

const AnalysisTableSpinner = ({ icon, text = "Analyzing" }) => (
  <span className="analysis-table__analyzing-state-container">
    <div className="analysis-table__loading-spinner-container">
      <TailSpin
        color="#2786ff"
        height={36}
        width={36}
        wrapperClass="analysis-table__loading-spinner"
      />
      <span
        className={`analysis-table__loading-spinner-containing-icon icon-${icon}`}
      />
    </div>
    <strong>{text}</strong>
  </span>
);

AnalysisTableSpinner.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string
};

export default AnalysisTableSpinner;
